(function () {
  function init(root) {
    if (!root || root.dataset.slInit) return;
    root.dataset.slInit = '1';

  
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-sl-tab]'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('[data-sl-panel]'));
  function activate(idx){
    tabs.forEach(function(t, i){
      var on = i === idx;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
    });
    panels.forEach(function(p, i){
      p.classList.toggle('sl-bt-on', i === idx);
    });
  }
  tabs.forEach(function(t, i){
    t.addEventListener('click', function(){ activate(i); });
    t.addEventListener('keydown', function(e){
      var n = null;
      if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
      else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') n = 0;
      else if (e.key === 'End') n = tabs.length - 1;
      if (n === null) return;
      e.preventDefault();
      activate(n);
      tabs[n].focus();
    });
  });

  
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sl-card]'));
  cards.forEach(function(card){
    card.style.setProperty('--d', card.getAttribute('data-sl-index'));
  });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('sl-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    cards.forEach(function(c){ io.observe(c); });
  } else {
    cards.forEach(function(c){ c.classList.add('sl-in'); });
  }

  cards.forEach(function(card){
    var dataEl = card.querySelector('[data-sl-variants]');
    var variants = null;
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch(err) { variants = null; } }

    var priceEl = card.querySelector('[data-sl-price]');
    var compEl  = card.querySelector('[data-sl-compare]');
    var atc     = card.querySelector('[data-sl-atc]');
    var label   = card.querySelector('[data-sl-atc-label]');
    var media   = card.querySelector('[data-sl-media]');

    function selected(n){
      var el;
      if (n === 2) { el = card.querySelector('[data-sl-flavor] input:checked'); }
      else { el = card.querySelector('[data-sl-opt="1"] input:checked'); }
      return el ? el.value : null;
    }
    function pop(el){
      if (!el) return;
      el.classList.remove('sl-price-pop');
      void el.offsetWidth;
      el.classList.add('sl-price-pop');
    }
    function refresh(){
      if (!variants || !atc) return;
      var v = null;
      var s1 = selected(1), s2 = selected(2);
      for (var i = 0; i < variants.length; i++) {
        var cand = variants[i];
        if (cand.o1 === s1 && (s2 === null || cand.o2 === s2)) { v = cand; break; }
      }
      if (!v) {
        atc.disabled = true;
        if (label) label.textContent = atc.getAttribute('data-t-soldout');
        return;
      }
      atc.setAttribute('data-variant-id', v.id);
      if (priceEl) { priceEl.textContent = v.p; pop(priceEl); }
      if (compEl) { if (v.c) { compEl.textContent = v.c; compEl.hidden = false; } else { compEl.hidden = true; } }
      atc.disabled = !v.av;
      if (label) label.textContent = v.av ? atc.getAttribute('data-t-add') : atc.getAttribute('data-t-soldout');
    }
    card.querySelectorAll('.sl-bs-pill input').forEach(function(inp){
      inp.addEventListener('change', refresh);
    });

    var chooser = card.querySelector('[data-sl-chooser]');
    function openChooser(){
      if (!chooser || !media) return;
      media.classList.add('sl-choosing');
      chooser.classList.add('sl-open');
    }
    function closeChooser(){
      if (!chooser || !media) return;
      media.classList.remove('sl-choosing');
      chooser.classList.remove('sl-open');
    }
    function doAdd(){
      if (!atc || atc.disabled || atc.dataset.busy) return;
      atc.dataset.busy = '1';
      atc.classList.add('sl-busy');
      if (label) label.textContent = atc.getAttribute('data-t-adding');
      fetch(root.getAttribute('data-sl-cart-add-url'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(atc.getAttribute('data-variant-id'), 10), quantity: 1 }] })
      }).then(function(r){
        if (!r.ok) throw new Error('add-failed');
        return r.json();
      }).then(function(){
        atc.classList.remove('sl-busy');
        atc.classList.add('sl-ok');
        if (label) label.textContent = atc.getAttribute('data-t-added');
        if (navigator.vibrate) { navigator.vibrate(12); }
        if (typeof window.monster_refresh === 'function') { window.monster_refresh(); }
        setTimeout(function(){
          atc.classList.remove('sl-ok');
          if (label) label.textContent = atc.getAttribute('data-t-add');
          delete atc.dataset.busy;
        }, 1800);
      }).catch(function(){
        atc.classList.remove('sl-busy');
        if (label) label.textContent = atc.getAttribute('data-t-add');
        delete atc.dataset.busy;
      });
    }
    if (atc && atc.hasAttribute('data-sl-atc')) {
      atc.addEventListener('click', function(){
        if (atc.disabled || atc.dataset.busy) return;
        if (chooser) { openChooser(); return; }
        doAdd();
      });
    }
    if (chooser) {
      chooser.querySelectorAll('input').forEach(function(inp){
        inp.addEventListener('click', function(){
          inp.checked = true;
          refresh();
          closeChooser();
          doAdd();
        });
      });
      var xBtn = chooser.querySelector('[data-sl-chooser-x]');
      if (xBtn) { xBtn.addEventListener('click', closeChooser); }
      document.addEventListener('click', function(e){
        if (!chooser.classList.contains('sl-open')) return;
        if (e.target.closest('[data-sl-chooser]') || e.target.closest('.sl-bs-atc')) return;
        closeChooser();
      });
      document.addEventListener('keydown', function(e){
        if (e.key === 'Escape') closeChooser();
      });
    }

    if (media && media.querySelector('.sl-bs-img--alt')) {
      var timer = null, peeked = false;
      media.addEventListener('contextmenu', function(e){ if (peeked) e.preventDefault(); });
      media.addEventListener('pointerdown', function(e){
        if (e.pointerType !== 'touch') return;
        if (e.target.closest('.sl-bs-atc') || e.target.closest('[data-sl-chooser]')) return;
        peeked = false;
        timer = setTimeout(function(){ media.classList.add('sl-peek'); peeked = true; }, 180);
      });
      function endPeek(){
        if (timer) { clearTimeout(timer); timer = null; }
        media.classList.remove('sl-peek');
      }
      media.addEventListener('pointerup', endPeek);
      media.addEventListener('pointercancel', endPeek);
      media.addEventListener('pointerleave', endPeek);
      media.addEventListener('click', function(e){
        if (peeked) { e.preventDefault(); peeked = false; }
      });
    }
  });
  }
  function initAll(scope) {
    var selector = '[data-sl-bestsellers-tabs]';
    if (scope.matches && scope.matches(selector)) init(scope);
    if (scope.querySelectorAll) scope.querySelectorAll(selector).forEach(init);
  }
  initAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
